import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1753583572865-7f75623c3114"
          alt="Цветя"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/20" />
        <span className="absolute bottom-10 left-10 font-serif text-4xl text-cream">Айлян<span className="text-clay">.</span></span>
      </div>
      <div className="flex items-center justify-center px-8 py-16">
        <form onSubmit={submit} className="w-full max-w-sm">
          <p className="text-xs uppercase tracking-[0.3em] text-clay font-medium mb-4">Административен вход</p>
          <h1 className="font-serif text-4xl text-ink mb-10">Добре дошла, Айлян</h1>

          {error && (
            <div className="mb-6 text-sm text-destructive bg-destructive/10 rounded-lg px-4 py-3" data-testid="login-error">
              {error}
            </div>
          )}

          <label className="text-xs uppercase tracking-[0.15em] text-stone">Имейл</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 mb-5 w-full bg-sand border border-line rounded-lg px-4 py-3 text-ink outline-none focus:border-clay transition-colors"
            data-testid="login-email"
          />
          <label className="text-xs uppercase tracking-[0.15em] text-stone">Парола</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 mb-8 w-full bg-sand border border-line rounded-lg px-4 py-3 text-ink outline-none focus:border-clay transition-colors"
            data-testid="login-password"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-ink text-cream py-4 rounded-full text-sm font-medium hover:bg-clay transition-colors duration-300 disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Влизане…" : "Вход"}
          </button>
          <a href="/" className="block text-center text-stone text-sm mt-6 hover:text-clay transition-colors">
            ← Обратно към сайта
          </a>
        </form>
      </div>
    </div>
  );
}
